import React from 'react';

const SlotsIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "16",
    height: "17",
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.3333 8.98802C12.7266 8.98802 14.6667 8.39106 14.6667 7.65468C14.6667 6.9183 12.7266 6.32135 10.3333 6.32135C7.9401 6.32135 6 6.9183 6 7.65468C6 8.39106 7.9401 8.98802 10.3333 8.98802Z",
      stroke: "#E2E4EE"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6667 10.6547C14.6667 11.3911 12.7266 11.988 10.3333 11.988C7.94007 11.988 6 11.3911 6 10.6547",
      stroke: "#E2E4EE"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.6667 7.65468V13.5213C14.6667 14.3313 12.7266 14.988 10.3333 14.988C7.94007 14.988 6 14.3313 6 13.5213V7.65468",
      stroke: "#E2E4EE"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.66634 4.32135C8.05958 4.32135 9.99967 3.7244 9.99967 2.98802C9.99967 2.25164 8.05958 1.65468 5.66634 1.65468C3.27311 1.65468 1.33301 2.25164 1.33301 2.98802C1.33301 3.7244 3.27311 4.32135 5.66634 4.32135Z",
      stroke: "#E2E4EE"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.99967 7.65468C2.73847 7.50122 1.57961 7.10435 1.33301 6.32135M3.99967 10.988C2.73847 10.8345 1.57961 10.4377 1.33301 9.65468",
      stroke: "#E2E4EE",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M3.99967 14.3214C2.73847 14.1679 1.57961 13.771 1.33301 12.988V2.98802",
      stroke: "#E2E4EE",
      strokeLinecap: "round"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M10 4.32135V2.98802", stroke: "#E2E4EE", strokeLinecap: "round" })
);
SlotsIcon.displayName = "Icons.SlotsIcon";

export { SlotsIcon };
//# sourceMappingURL=SlotsIcon.js.map
